import toastMessage from "../../utils/toastMessage";
import language from "../../language";
import formatDropdownData from "../../utils/formatDropdownData";
import axios from "axios";
import { getStorage, setStorage } from "../../utils/storage";
import api from "../../utils/api";

export const getAccountMerchantProfileInfo = async (
  lng = "english",
  params
) => {
  const { listType } = params || {};
  let user = await getStorage();

  try {
    let headers = {
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: "Bearer " + user.accessToken,
    };

    const options = {
      method: "GET",
      url: `${api("profile")}`,
      data: null, //force axios send headers content type
      headers,
    };

    const data = await axios(options);

    if (data.data) {
      user.userId = data.data.userId;
      user.categoryName = data.data.categoryName;
      user.accountCategoryId = data.data.accountCategoryId;
      user.countryId = data.data.countryId;
      user.country = data.data.country;

      setStorage(user);
    }

    if (listType === "dropdown") {
      return formatDropdownData(data.data, "name", "id");
    }

    return data.data;
  } catch (error) {
    toastMessage("error", language[lng].unable_to_fetch_merchant_profile);
  }
};

export const fetchBusinessProfile = async (lng = "english", params) => {
  const { listType } = params || {};
  const { accessToken } = await getStorage();

  try {
    let headers = {
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: "Bearer " + accessToken,
    };

    const options = {
      method: "GET",
      url: `${api("profile")}/business`,
      data: null, //force axios send headers content type
      headers,
    };

    const data = await axios(options);

    if (listType === "dropdown") {
      return formatDropdownData(data.data, "name", "id");
    }

    if (data.data instanceof Object) {
      return [data.data];
    } else {
      return data.data;
    }
  } catch (error) {
    toastMessage("error", language[lng].unable_to_fetch_merchant_profile);
  }
};

export const deleteBusinessProfile = async (lng = "english", id) => {
  try {
    const user = await getStorage();

    const options = {
      method: "DELETE",
      url: `${api("profile")}/business`,
      data: {
        id,
      },
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    };

    await axios(options);

    toastMessage("success", language[lng].success_delete_business_profile);
  } catch (error) {
    toastMessage("error", language[lng].error_delete_business_profile);
  }
};
